export default class Emitter {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    exec() {
        if (this[this.gb.rgsProtocol + "_handler"] && typeof this[this.gb.rgsProtocol + "_handler"] === "function") {
            this.usingHandler = this.gb.rgsProtocol;
            this[this.gb.rgsProtocol + "_handler"].apply(this, arguments);
        } else if (this[this.gb.gameProviderProtocol + "_handler"] && typeof this[this.gb.gameProviderProtocol + "_handler"] === "function") {
            this.usingHandler = this.gb.gameProviderProtocol;
            this[this.gb.gameProviderProtocol + "_handler"].apply(this, arguments);
        } else {
            this.usingHandler = "_default";
            this._default.apply(this, arguments);
        }
    }

    emitGame(msg) {
        this.gb.gameIframe.contentWindow.postMessage(msg, "*");
        logger.debug(`Emitting '${this.constructor.name}' to ${this.usingHandler} GAME`, msg);
    }
}
